export const FormLabel = {
  sizes: {
    lg: {
      fontSize: ['md', null, 'lg'],
      mb: 2
    },
    md: {
      fontSize: 'sm',
      mb: 2
    },
    sm: {
      fontSize: 'xs',
      mb: 1
    },
    xs: {
      fontSize: '2xs',
      mb: 1
    }
  },
  baseStyle: {
    fontFamily: 'heading',
    fontWeight: 'semibold',
    color: 'brand.muted'
  },
  defaultProps: {
    size: 'sm'
  }
}
